/*
Author: Jude Fernando
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

const Debug = (props:any) => {
    const {node, children} = props
    //delete node.nodes; 
    return (
        <div className="p-5 border border-red-500">
            <div className="text-red-500">Component Not Found : {node.type}</div>
            <pre className="w-100 p-3 border-red-300 bg-red-100">{JSON.stringify(node, null, 2)}</pre>
            {children}
        </div>
    )
}

export default Debug;